import {LogoutOutlined as LogoutOutlinedIcon} from '@mui/icons-material';
import {
  Button,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, {Fragment} from 'react';

import UserAvatar from '../UserAvatar.jsx';
import NavMenuButton from './NavMenuButton.jsx';

/**
 * A user menu for the NavBar
 */
const UserMenu = ({user, logout, login, loginText = 'Log In', children}) => {
  return (
    <Fragment>
      {user ? (
        <NavMenuButton
          label={<UserAvatar user={user} size="xsmall" />}
          title={
            user?.name || user?.email ? (
              <Fragment>
                <div>{user.name}</div>
                <div>{user.email}</div>
              </Fragment>
            ) : (
              ''
            )
          }
        >
          <ListItem
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <UserAvatar user={user} size="small" />
            <ListItemText
              primary={user.name}
              slotProps={{primary: {variant: 'overline'}}}
              secondary={user.email}
            />
          </ListItem>
          {children && <Divider sx={{marginY: 1}} />}
          {children}
          {logout && <Divider sx={{marginY: 1}} />}
          {logout && (
            <MenuItem onClick={logout}>
              <ListItemIcon>
                <LogoutOutlinedIcon />
              </ListItemIcon>
              <ListItemText>Log Out</ListItemText>
            </MenuItem>
          )}
        </NavMenuButton>
      ) : (
        login && (
          <Tooltip title="Log in to your Planet account">
            <Button color="primary" onClick={login}>
              {loginText}
            </Button>
          </Tooltip>
        )
      )}
    </Fragment>
  );
};

UserMenu.propTypes = {
  /**
   The Planet user object
  */
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
  }),
  /**
   Callback function called when the logout button is clicked
  */
  logout: PropTypes.func,
  /**
   Callback function called when the login button is clicked
  */
  login: PropTypes.func,

  /**
   Text to display on the login button
  */
  loginText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   (Additional) Contents of the user menu
  */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default UserMenu;
